export default {
  title: 'Prezentare generală',
  table_title: 'Rezervări',
  filters: {
    card_title: 'Filtre',
    today: 'Astăzi',
    upcoming: 'Viitoare',
    past: 'Trecute',
    all: 'Toate',
    all_dates: 'Tot timpul',
    pending: 'În așteptarea confirmării',
    canceled: 'Anulate',
    removed: 'Eliminate',
    date_label: 'Dată:',
    status_label: 'Stare:',
    source_label: 'Sursă:',
    source_website: 'Website',
    source_google: 'Google',
    search_label: 'Căutare:',
    search_placeholder: 'Căutați după prenume sau nume de familie',
    custom_date_tooltip: 'Alegeți o dată specifică',
    active_label: 'Filtre active:',
    clear_all: 'Șterge tot',
  },
  tooltips: {
    total_reservations: 'Total rezervări',
    total_guests: 'Total oaspeți',
    refresh: 'Reîmprospătare',
  },
  empty: {
    default: 'Nicio rezervare încă.',
    filtered: 'Nicio rezervare nu corespunde filtrelor.',
  },
  fields: {
    company: 'Restaurant',
    datetime: 'Dată / oră',
    customer: 'Client',
    source: 'Sursă',
    guests: 'Oaspeți',
    status: 'Stare',
    created_at: 'Creat la',
  },
  status: {
    confirmed: 'Confirmat',
    pending: 'În așteptarea aprobării',
    canceled: 'Anulate',
    rejected: 'Respins',
    removed: 'Eliminate',
  },
  buttons: {
    details: 'Detalii',
    add_reservation: 'Adaugă rezervare',
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
  },
};
